import { isEmpty } from "lodash-es";
export function makeHttpJSONRequest(body, opts = {
  method: "post",
  headers: {},
  url: null
}) {
  if (!process.env.API_URL) throw new Error("API_URL in env is not provided ");
  const fetchRequest = {
    headers: {
      "content-type": "application/json",
      ...opts.headers ? cleanHeaders(opts.headers) : void 0
    },
    method: opts.method,
    ...cleanBody(body)
  };
  if (isEmpty(body) && opts.method === "get") {
    delete fetchRequest.body;
  }
  return fetch(opts?.url || process.env.API_URL || "", fetchRequest);
}
export function makeHttpSimpleJSONRequest(method, endpoint, body, headers) {
  const response = fetch(endpoint, {
    headers: {
      "content-type": "application/json",
      ...headers || {}
    },
    method,
    body: JSON.stringify(body)
  });
  return response.then((res) => res.json());
}
export async function parseResponse(response) {
  let json;
  const responseData = {
    ok: response.ok,
    statusText: response.statusText,
    status: response.status,
    headers: response.headers
  };
  try {
    json = await response.json();
  } catch (err) {
    return {
      ...responseData,
      statusText: err.message,
      body: null
    };
  }
  return {
    ...responseData,
    body: json
  };
}
export function cleanHeaders(headers) {
  const allowedHeaders = [
    "content-type",
    "authorization",
    "store",
    "content-language"
  ];
  const cleanedHeaders = {};
  Object.keys(headers).forEach((header) => {
    if (header && allowedHeaders.includes(header)) {
      cleanedHeaders[header] = headers[header];
    }
  });
  return cleanedHeaders;
}
export function cleanBody(body) {
  return body ? { body: JSON.stringify(body) } : void 0;
}
